import { inject } from '@angular/core'
import { CanMatchFn } from '@angular/router'
import { AuthService } from '@services'

export const loggedInMatch: CanMatchFn = () => {
  const auth = inject(AuthService)
  return auth.isLoggedIn()
}

export const loggedOutMatch: CanMatchFn = () => {
  const auth = inject(AuthService)
  return !auth.isLoggedIn()
}

export const requireAuthMatch: CanMatchFn = () => {
  const auth = inject(AuthService)
  return auth.isLoggedIn()
}
